export const ECLIPSE_DEALER_REAL_ESTATE_ID = '5f4fda7d-40d5-449e-b672-bed3da55ffc6';
export const DealerPlacementIds = {
  APP_INTENT_INITIAL_PURCHASE: '5f4fda7d-40d5-449e-b672-bed3da55ffc6',
  APP_INTENT_SECOND_UPGRADE: '835f042a-1e0f-4c52-b076-8359f6bc5ec1',
  ACCEPTED_PAYMENT_METHODS: '4c0d792b-9946-4571-a819-2528f1fca5fc'
};
//# sourceMappingURL=dealer-types.js.map